import axios from "axios";

// Base Axios instance
const api = axios.create({
  baseURL: "https://zulaykha-backend.vercel.app/auth",
  headers: {
    "Content-Type": "application/json",
  },
});

// Signup
export const signup = async (userData) => {
  const response = await api.post("/signup", userData);
  return response.data;
};

// Login
export const login = async (credentials) => {
  const response = await api.post("/login", credentials);
  return response.data;
};

// Forgot Password
export const forgotPassword = async (email) => {
  const response = await api.post("/forgotPassword", { email });
  return response.data;
};

// Reset Password
export const resetPassword = async (token, newPassword) => {
  const response = await api.post("/resetPassword", { token, newPassword });
  console.log(response);
  return response.data;
};

// Get All Users
export const getAllUsers = async () => {
  const response = await api.get("/");
  return response.data;
};

// Register a Class
export const registerClass = async (classData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post("https://backend-ashen-theta.vercel.app/api/v1/class/register", classData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
